import React from 'react';
import style from './header.module.scss';
import logo from './8x8-logo.svg';


export const Header = () => {
  return (
    <div className={style.headerWraper}>
      <img className={style.logo} alt="logo" src={logo} />
    </div>
  );
};
